// extracted by mini-css-extract-plugin
export var orderSummary = "_r1-0";
export var showMoreLessButton = "_r1-1";